(function(){
  var money=function(c){return (c/100).toFixed(2).replace('.',',')+' €';};
  function openCart(){var b=document.querySelector('[data-cart-open]');if(b)b.click();else location.href='/cart';}
  function post(url,body){return fetch(url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)}).then(function(r){if(!r.ok)throw 0;return r.json();});}
  function place(){
    var all=document.querySelectorAll('[data-pack]');
    for(var i=1;i<all.length;i++)all[i].remove();
    var p=all[0];if(!p||p.dataset.placed)return;
    var btn=document.querySelector('form[data-ajax-form] [data-add-btn]');
    if(btn&&btn.parentNode){btn.parentNode.insertBefore(p,btn);}
    p.dataset.placed='1';
  }
  function refresh(p){
    var t=0,n=0;p.querySelectorAll('[data-pack-cb]:checked').forEach(function(c){t+=+c.dataset.price;n++;});
    var b=p.querySelector('[data-pack-add]');b.hidden=!n;
    var main=+p.dataset.mainPrice,sum=t+main,el=p.querySelector('[data-pack-total]');
    if(n){
      var net=Math.round(sum*0.95);
      el.innerHTML='<s style="opacity:.6">'+money(sum)+'</s> '+money(net)+' <small>(−5 % inclus)</small>';
    } else el.textContent='';
  }
  document.addEventListener('change',function(e){var p=e.target.closest&&e.target.closest('[data-pack]');if(p&&e.target.matches('[data-pack-cb]'))refresh(p);});
  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('[data-pack-add]');
    if(a){
      var p=a.closest('[data-pack]'),f=document.querySelector('form[data-ajax-form]');if(!f)return;
      var id=f.querySelector('[name=id]').value,q=+(f.querySelector('[name=quantity]')||{value:1}).value||1;
      var items=[{id:+id,quantity:q}];
      p.querySelectorAll('[data-pack-cb]:checked').forEach(function(c){items.push({id:+c.dataset.variant,quantity:1});});
      a.disabled=true;
      post('/cart/add.js',{items:items}).then(openCart).catch(function(){a.disabled=false;alert('Un article n’est plus disponible.');});
      return;
    }
    var s=e.target.closest&&e.target.closest('[data-up-swap]');
    if(s){
      s.disabled=true;
      post('/cart/change.js',{id:s.dataset.from,quantity:0}).then(function(){return post('/cart/add.js',{items:[{id:+s.dataset.to,quantity:1}]});}).then(function(){openCart();}).catch(function(){location.reload();});
      return;
    }
    var c=e.target.closest&&e.target.closest('[data-cart-suggest]');
    if(c){c.disabled=true;post('/cart/add.js',{items:[{id:+c.dataset.variant,quantity:1}]}).then(openCart).catch(function(){c.disabled=false;});}
  });
  if(document.readyState!=='loading')place();else document.addEventListener('DOMContentLoaded',place);
})();
